import { openBlock as e, createElementBlock as t, createElementVNode as o } from "vue";
const c = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}, n = /* @__PURE__ */ o("circle", {
  cx: "10",
  cy: "10",
  r: "4",
  fill: "currentColor"
}, null, -1), r = [
  n
];
function l(s, i) {
  return e(), t("svg", c, [...r]);
}
const d = { render: l };
export {
  d as default,
  l as render
};
